import { z } from 'zod'

const Env = z.object({
  VITE_API_URL: z.string().url().default('http://localhost:4000'),
  VITE_WS_URL: z.string().url().default('http://localhost:4000'),
  VITE_DEFAULT_TENANT_SLUG: z.string().optional(),
  // logo.dev publishable token (pk_...) — safe to expose. When absent the
  // CompanyLogo component skips logo.dev and falls back to initials.
  VITE_LOGODEV_TOKEN: z.string().optional(),
})

const parsed = Env.safeParse(import.meta.env)
if (!parsed.success) {
  // eslint-disable-next-line no-console
  console.error('Invalid frontend env:', parsed.error.flatten().fieldErrors)
  throw new Error('Missing/invalid VITE_* environment variables')
}

export const env = parsed.data
export type Env = z.infer<typeof Env>
